import { render } from "./PedidoEmAndamentoFluxo.vue?vue&type=template&id=0067be44"
import script from "./PedidoEmAndamentoFluxo.vue?vue&type=script&lang=js"
export * from "./PedidoEmAndamentoFluxo.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__